import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "close-circle--sprite",
  "use": "close-circle--sprite-usage",
  "viewBox": "0 0 32 33",
  "content": "<symbol viewBox=\"0 0 32 33\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"close-circle--sprite\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M20.6667 12.7734L19.7267 11.8334L16 15.56L12.2734 11.8334L11.3334 12.7734L15.06 16.5L11.3334 20.2267L12.2734 21.1667L16 17.44L19.7267 21.1667L20.6667 20.2267L16.94 16.5L20.6667 12.7734Z\" fill=\"#828282\" />\n<rect x=\"0.5\" y=\"1\" width=\"31\" height=\"31\" rx=\"15.5\" stroke=\"#828282\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol